export const habaCart = {
  habaAddToCartPopup: {
    headline: 'Item added to cart',
    toCart: 'View cart',
    continue: 'Continue shopping',
    recommendationsTitle: 'Products you might also like',
    add: 'Add',
    added: 'Added',
    quantity: 'Quantity:',
  },

  habaVoucher: {
    coupon: 'Do you have a gift card or promotional code?',
    apply: 'Redeem',
    placeholder: 'Enter code',
    error: 'Please enter a valid code.',
    applyVoucherSuccess: '{{voucherCode}} was successfully redeemed.',
    removeVoucherSuccess: '{{voucherCode}} was removed.',
    availableCoupons: 'Redeemable coupons',
    availableCouponsLabel: 'You can add these coupons to your order.',
    vouchersApplied: 'Redeemed gift cards:',
    promotionInfo: {
      headline: 'All information and conditions',
      labelPromo: 'Promotional code',
      labelCampaign: 'Campaign',
    },
    giftCardInsolvencyInputMessageFindMore: 'You can find more information here.',
    giftCardInsolvencyClose: 'Close',
    giftCardInsolvencySorryMessage: 'We are sorry!',
    giftCardInsolvencyMessage1:
      'Our company is currently undergoing insolvency proceedings under self-administration.',
    giftCardInsolvencyMessage2: 'If the gift card was purchased before 12.09.2023, the ',
    giftCardInsolvencyMessage3:
      'credit is part of the proceedings and unfortunately cannot be redeemed at the moment.',
    giftCardInsolvencyMessage4:
      'As a small apology, we have added a special discount to your cart.',
    giftCardInsolvencyMessage5:
      'After the opening of the self-administration proceedings (expected on 01.12.2023), you can register and assert your claim in the insolvency table.',
    disabledGiftcardsMessage:
      'Promotional codes and gift cards unfortunately cannot be used at the moment. This function will be available again soon.',
  },

  habaMiniCart: {
    cart: 'Cart',
    title: 'Your cart',
    emptyCart: 'Cart empty.',
    viewCart: 'View cart',
    anonymousPopup: {
      headline: 'Missing your products?',
      text: 'Sign in to see your recent products in the cart.',
      headlineHaba: 'Missing your products?',
      textHaba: 'Sign in with your customer account and benefit from quick orders and discounts.',
      button: 'Sign in',
    },
    emptyCartPopupText: 'You have no items in your cart.',
    emptyCartPopupTextHaba: 'You have no items in your cart',
  },
  habaCart: {
    emptyCartTitle: 'Your cart',
    emptyCartDescription:
      'Add products to your cart by browsing the shop and adding products to your cart.',
    emptyCartButtonText: 'Start browsing now',
    myCart: 'My Cart',
    toHome: 'To homepage',
    payPalExpressInfo: 'Pay & order quickly with',
    informationAndConditions: 'All information and conditions',
    backToCart: 'Back to cart',
  },
  cartProductReplaceErrors: {
    quantityReduced:
      'The desired quantity is unfortunately no longer available. The maximum available quantity has been adjusted.',
    maxOrderQuantityExceeded: 'Requested quantities no longer available. Quantities changed.',
    productNotFound: 'Unfortunately, the product is not available.',
    lowStock: 'We are sorry, but the desired product is no longer available in the meantime.',
  },
  habaCartDetails: {
    productsValue: 'Product value',
    details: {
      initialPrice: 'Original product value',
      reductions: 'Your savings',
      currentPrice: 'Product value',
      currentPriceDetails: '(all promotions applied)',
      returnVoucher: 'Gift card redemption',
      deliveryCost: 'Shipping costs (free from {{amount}})',
      total: 'Total amount',
    },
  },
};
